/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTheme } from "@mui/material/styles";
import { getIcon } from "cms/fields/field-utils";

const FieldIcon = (props) => {
    const theme = useTheme();
    const className = props?.className;
    const type = props?.type;

    if (!type) {
        return null;
    }

    const tileIconFillStyle = {
        fill: theme.palette.secondary.main
    };
    const Icon = getIcon(type);
    let classArray = ["simplicity-component-icon"];
    if (className) {
        classArray.push(className);
    }
    const classList = classArray.join(" ");

    return (
        <Icon style={tileIconFillStyle} className={classList} />
    );
};

export { FieldIcon };
